import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import {
  BackofficeKnowledgeCategoriesResponseDataSchema,
  DataResponse,
  GetBackofficeKnowledgeMetricsSchema,
} from "schema"
import { z } from "zod"

type Query = z.input<typeof GetBackofficeKnowledgeMetricsSchema>
type Response = DataResponse<z.infer<typeof BackofficeKnowledgeCategoriesResponseDataSchema>>

export const getBackofficeKnowledgeCategoriesQuery = ({ query }: { query: Query }) => {
  return queryOptions({
    placeholderData: () => undefined,
    queryKey: ["backofficeKnowledgeCategories", query],
    queryFn: async ({ signal }) => {
      const { data } = await axios.get<Response>("/backoffice/knowledge/categories", {
        params: query,
        signal,
      })
      return data.data
    },
  })
}
